export default __webpack_public_path__ + "static/media/img4.248e8f82.jpg";